import * as React from "react";

import primaryColour from "../../constants";

function SvgDriverlogon(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.40424 18.5045C4.44767 18.4581 4.4914 18.4127 4.53599 18.3681C5.49482 17.3544 6.65274 16.5498 7.93715 16.0046C9.22156 15.4595 10.6048 15.1856 12 15.2001C13.3944 15.1912 14.7759 15.4677 16.0595 16.0125C17.3431 16.5573 18.5017 17.359 19.464 18.3681C19.5086 18.4127 19.5523 18.4582 19.5958 18.5045C17.7617 20.6442 15.0392 22 12 22C8.96081 22 6.23828 20.6442 4.40424 18.5045Z"
        fill={fill}
      />
      <path
        d="M14.2223 6.27422C13.5645 5.83469 12.7911 5.6001 12 5.6001C10.9391 5.6001 9.92171 6.02152 9.17157 6.77167C8.42142 7.52182 7.99999 8.53923 7.99999 9.6001C7.99999 10.3912 8.23459 11.1646 8.67411 11.8224C9.11364 12.4802 9.73835 12.9929 10.4693 13.2956C11.2002 13.5984 12.0044 13.6776 12.7804 13.5232C13.5563 13.3689 14.269 12.9879 14.8284 12.4285C15.3878 11.8691 15.7688 11.1564 15.9231 10.3805C16.0775 9.60453 15.9983 8.80027 15.6955 8.06936C15.3928 7.33846 14.8801 6.71374 14.2223 6.27422Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgDriverlogon;
